import { ArrowRightIcon } from "lucide-react";
import { CTA_URL } from "./constants";
import { trackMetaEvent } from "./MetaPixel";
type Props = {
  label: string;
  className?: string;
  onClick?: () => void;
};
export function CtaButton({
  label,
  className = "",
  onClick
}: Props) {
  const track = () => {
    trackMetaEvent("InitiateCheckout");
    onClick?.();
  };
  return <a href={CTA_URL} onClick={track} className={`group relative flex w-full items-center justify-center gap-2 rounded-2xl bg-[#f5a623] px-5 py-4 text-center font-head text-base font-800 uppercase tracking-wide text-[#0a1a34] shadow-[0_10px_30px_-6px_rgba(245,166,35,0.6)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#ffb733] hover:shadow-[0_14px_34px_-6px_rgba(245,166,35,0.7)] active:translate-y-0 sm:text-lg ${className}`} data-id="element-73" data-mp="cmvjjeywbrrd">
      <span className="leading-tight" data-id="element-74" data-mp="19buskw7b0xkm">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-75" data-mp="159q40bvpqr4u" />
    </a>;
}